import CheckboxWithInfoAndValue, {
  CheckboxWithInfoAndValueProps,
} from './CheckboxWithInfoAndValue';
export type { CheckboxWithInfoAndValueProps };

export default CheckboxWithInfoAndValue;
